<template>
  <button tabindex="1" class="activ-bot-opt" :class="botActiv?'activo':''">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    botActiv: {
      type: Boolean,
      required: false
    }
  }
}
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
@import "../../sass/helpers/variables";
.activ-bot-opt{
  padding: 5px;
  border-radius: 8px;
  margin: 2px 5px;
  width: 100%;
  max-width: 300px;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1.3rem;
  background-color: $white-dav;
  @include shadow(0 2px 7px #444);
  &:hover{
    background-color: #f6d7d0;
  }
  &.activo{
    background-color: $secondary-red;
    color: white;
  }
}
</style>




// WEBPACK FOOTER //
// ActividadDeciBotonOpt.vue?2f5992c1